import React from "react";
import ShareButtons from "../../../../utility/ShareButtons";
import useServiceData from "../../../../utility/useServiceData";
import FAQAccordion from "../../../../utility/FAQAccordion";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import Slider from "react-slick";
import CheckList from "../../../../utility/serviceTemplateutility/CheckList";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesigntwo";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
export default function Endosphere() {
  const serviceUrl = window.location.href;
  const data = useServiceData("Endosphere");
  const imageUrl = data?.image_url;
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "1. Is Endosphere Therapy painful?",
      answer:
        "No, the treatment is completely pain-free and is often described as a relaxing massage.",
    },
    {
      question: "2. How many sessions are needed to see results?",
      answer:
        "Many clients notice immediate improvements after the first session, but a series of treatments is recommended for optimal, long-term results.",
    },
    {
      question: "3. Can anyone undergo Endosphere Therapy?",
      answer:
        "This therapy is suitable for most individuals. However, our specialists will assess your suitability during the initial consultation.",
    },
    {
      question: "4. Are there any side effects?",
      answer:
        "No, this is a non-invasive procedure with no known side effects. There is no downtime, redness, or soreness post-treatment.",
    },
    {
      question: "5. How long does each session take?",
      answer:
        "Each session typically lasts around 45 to 60 minutes, depending on the treatment area and individual needs.",
    },
  ];

  const images = [
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-2.jpg",
      alt: "weight loss clinic in dubai",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Cryolipolysis-services-in-dubai-eBH-3.jpg",
      alt: "Cryolipolysis services in dubai eBH (3)",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Before-After-Service-Images-1.jpg",
      alt: "Before & After Service Images (1)",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Cryolipolysis-services-in-dubai-eBH-1.jpg",
      alt: "Cryolipolysis services in dubai eBH (1)",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const prepCheckList = [
    {
      text: "Hydrate: Drink plenty of water before and after your session to aid lymphatic drainage.",
    },
    {
      text: "Dress Comfortably: Wear loose-fitting clothing for easy preparation.",
    },
    { text: "Avoid Heavy Meals: Ensure a light stomach before your session." },
  ];

  const benefitsCheckList = [
    {
      text: "Reduce Cellulite: Smooth out uneven skin texture by breaking down fat deposits.",
    },
    {
      text: "Contour Body: Achieve a sculpted figure in problem areas.",
    },
    {
      text: "Tighten Skin: Boost collagen production for youthful, firm skin.",
    },
    {
      text: "Better Circulation: Enhance blood flow for healthier skin and reduced swelling.",
    },
    {
      text: "Pain Relief: Alleviate muscle tension and soreness.",
    },
    {
      text: "Lymphatic Drainage: Detoxify your body by promoting lymphatic flow.",
    },
    {
      text: "No Side Effects: A safe, non-invasive procedure suitable for most clients.",
    },
  ];

  const endospheresSteps = [
    { heading: "How is Endosphere Therapy Performed?" },
    {
      title: "Initial Consultation",
      desc: "It starts with an in-depth consultation. The specialists evaluate your goals, body type, and different areas you want to focus on to create a custom treatment plan.",
      icon: "fa-solid fa-user-doctor",
    },
    {
      title: "Preparation",
      desc: "You will be in a relaxed position on a medical couch. A specially designed massage oil is used so that the device can easily glide across your skin.",
      icon: "fa-solid fa-couch",
    },
    {
      title: "Treatment",
      desc: "Performed with the Endospheres Evolution device using silicone rollers and vibrating spheres, tailored to your needs. Targets include fat reduction, blood circulation, and lymphatic drainage.",
      icon: "fa-solid fa-spa",
    },
    {
      title: "Fat Layer Reduction",
      desc: "Breaks down stubborn fat deposits, helping reshape and contour the body.",
      icon: "fa-solid fa-weight",
    },
    {
      title: "Enhanced Blood Circulation",
      desc: "Stimulates blood flow, revitalizing treated areas and improving oxygen supply.",
      icon: "fa-solid fa-heart-pulse",
    },
    {
      title: "Improved Lymphatic Drainage",
      desc: "Supports detoxification and reduces water retention by stimulating the lymphatic system.",
      icon: "fa-solid fa-droplet",
    },
    {
      title: "After Treatment",
      desc: "You can start your day as per usual without a problem. No redness, no soreness, no rehabilitation needed.",
      icon: "fa-solid fa-calendar-check",
    },
  ];

  return (
    <>
      <title>Endosphere Therapy -</title>
      <meta
        name="description"
        content="At Elite Body Home, we offer Endosphere Therapy with cutting-edge, patented hardware massage technology to help you achieve your ideal body shape"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/endosphere-therapy/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Endosphere Therapy -" />
      <meta
        property="og:description"
        content="At Elite Body Home, we offer Endosphere Therapy with cutting-edge, patented hardware massage technology to help you achieve your ideal body shape"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/endosphere-therapy/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-01-23T09:27:25+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dfsf.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dfsf.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Endosphere Therapy" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Endosphere Therapy -" />
      <meta
        name="twitter:description"
        content="At Elite Body Home, we offer Endosphere Therapy with cutting-edge, patented hardware massage technology to help you achieve your ideal body shape"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dfsf.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <section className="overflow-hidden ">
          <div className="position-relative mb-3">
            <img
              src={imageUrl}
              alt="full face botox dubai"
              className="img-fluid w-100 rounded mt-2 "
              style={{
                height: "500px",
                objectFit: "cover",
                objectPosition: "top",
                border: "2px solid #c69933",
                borderRadius: "100px",
              }}
            />
          </div>
        </section>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Endosphere Therapy
                </li>
              </ol>
            </nav>
            <div>
              <h1
                className="display-4 fw-semibold"
                style={{
                  color: "#c69933",
                }}
              >
                Endosphere Therapy
              </h1>
            </div>
            <QuickNavigation />
            <div>
              <div>
                <h3 className="title">
                  <span>Transform Your</span>
                  <span>
                    <span>Body Shape</span>
                  </span>
                </h3>
              </div>
              <div>
                <p>
                  Endosphere Therapy at Elite Body Home using advanced patented
                  hardware massage technology to help you obtain your perfect
                  body easily. Utilizing micro vibration and microcompression,
                  this non-invasive and painless procedure focuses on ailments
                  concerning cellulite, body reshaping, unwanted weight loss,
                  and fits conveniently into your daily life (no preparation or
                  downtime needed).
                </p>
              </div>
            </div>
            <div id="procedures">
              <CardDesign carditems={endospheresSteps} />
            </div>
            <div id="benefits">
              <CheckList
                items={benefitsCheckList}
                title="Benefits for Your Body"
              />
            </div>

            <div id="preparations">
              <CheckList
                items={prepCheckList}
                title=" Preparation for Your Session"
                description="Minimal preparation is required for Endosphere Therapy. For the best experience"
              />
            </div>

            <div className="container py-4">
              <Slider {...settings}>
                {images.map((img, idx) => (
                  <div key={idx}>
                    <div className="card border-0 ">
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="card-img-top img-fluid"
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <WhyUs language="en" />
            <FAQAccordion faqData={faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
